import { Field, FieldInputProps, FormikProps } from "formik";
import NumberCell from "./NumberCell";
import { useState } from "react";

interface CellProps {
  fieldNameFlat: string;
  fieldNamePercent: string;
  form: FormikProps<any>;
}

// Helper function to get nested property value using a string path
const getNestedValue = (obj: any, path: string) => {
  return path
    .split(/[\[\].]+/)
    .filter(Boolean)
    .reduce((result, key) => {
      return result !== undefined ? result[key] : undefined;
    }, obj);
};

const FinancesTableBonusCell: React.FC<CellProps> = ({
  fieldNameFlat,
  fieldNamePercent,
  form,
}) => {
  const flatValue = getNestedValue(form.values, fieldNameFlat);

  const [isPercentMode, setIsPercentMode] = useState(flatValue ? false : true);
  const toggleMode = () => {
    if (!isPercentMode) {
      form.setFieldValue(fieldNameFlat, 0);
    } else {
      form.setFieldValue(fieldNamePercent, 0);
    }
    setIsPercentMode(!isPercentMode);
  };

  return (
    <td className="flex-1 px-2 h-10 truncate whitespace-nowrap overflow-hidden">
      <Field name={isPercentMode ? fieldNamePercent : fieldNameFlat}>
        {({
          field,
          form,
        }: {
          field: FieldInputProps<any>;
          form: FormikProps<any>;
        }) => {
          const onBlur = (e: React.FocusEvent<any>) => {
            field.onBlur(e);
            if (form.dirty) {
              form.handleSubmit(e);
            }
          };
          return (
            <div className="flex items-center gap-2">
              <div className="flex rounded-md border">
                <button
                  type="button"
                  className={`px-2 py-1 ${
                    !isPercentMode ? "bg-gray-200" : "bg-white"
                  }`}
                  onClick={(e) => toggleMode()}
                >
                  #
                </button>
                <button
                  type="button"
                  className={`px-2 py-1 ${
                    isPercentMode ? "bg-gray-200" : "bg-white"
                  }`}
                  onClick={(e) => toggleMode()}
                >
                  %
                </button>
              </div>
              <NumberCell
                {...field}
                onBlur={onBlur}
                isPercentage={isPercentMode}
              />
            </div>
          );
        }}
      </Field>
    </td>
  );
};

export default FinancesTableBonusCell;
